// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Change colors in this file to style to your needs on a global level. 
Certain colors are used for different and multiply types of elements. 
For greater control over colors visit each components .scss file. */
.education-card {
  display: flex;
  flex-direction: row;
}

.education-card:hover + .education-card-border {
  border-color: #a9a7f9;
  width: 100%;
  transition: width 0.6s ease-in-out;
}

.education-card-border {
  height: 30px;
  width: 80%;
  border-top: 2px solid rgba(211, 211, 211, 0.397);
  margin-bottom: 20px;
  transition: width 0.6s ease-in-out;
}

.education-head {
  display: flex;
  flex-direction: row;
}

.education-text-school {
  margin: 0;
  font-size: 28px;
  font-weight: 700;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  height: 27px;
}

.education-roundedimg {
  object-fit: cover;
  margin-right: 2rem;
  width: 6rem;
  height: 6rem;
  box-shadow: 0 0.5rem 1rem rgba(0, 0, 0, 0.3);
  border-radius: 50%;
}

.education-card-right {
  max-width: 70%;
}

.education-text-subHeader {
  color: #000000;
  font-weight: 700;
  font-size: 19px;
  margin: 0px;
  padding-top: 0.8rem;
  line-height: normal;
}

.education-text-duration {
  color: #000000;
  font-size: 19px;
  margin: 0px;
  padding-top: 0.5rem;
}

.education-text-desc {
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
}

.education-text-bullets > ul {
  margin-top: 0.5rem;
}

/* Media Query */
@media (max-width: 1380px) {
  .education-card {
    flex-direction: column;
    padding-bottom: 10px;
  }
  .education-card-right {
    max-width: 90%;
  }
  .education-card-border {
    width: 90%;
  }
  .education-text-subHeader {
    padding-top: 0.5rem;
    font-size: 16px;
  }
  .education-text-school {
    font-size: 20px;
    height: 23px;
  }
  .education-text-duration {
    font-size: 16px;
  }
  .education-roundedimg {
    width: 4rem;
    height: 4rem;
    margin-bottom: 0.5rem;
    margin-right: 0px;
  }
}
@media (max-width: 768px) {
  .education-card {
    text-align: center;
  }
  .education-card-right {
    max-width: 100%;
  }
  .education-card-border {
    width: 100%;
  }
  .education-roundedimg {
    margin-top: 10px;
    width: 4rem;
    height: 4rem;
    margin-bottom: 1rem;
    margin-right: 0;
  }
  .education-text-bullets > ul {
    max-width: 80%;
    margin: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/_globalColor.scss","webpack://./src/components/educationCard/EducationCard.scss"],"names":[],"mappings":"AAAA;;mEAAA;ACEA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,qBDsDoB;ECrDpB,WAAA;EAIA,kCAAA;AAEF;;AACA;EACE,YAAA;EACA,UAAA;EACA,gDAAA;EACA,mBAAA;EAIA,kCAAA;AAEF;;AACA;EACE,aAAA;EACA,mBAAA;AAEF;;AACA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,uBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,4CAAA;EACA,kBAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,cD7CU;EC8CV,gBAAA;EACA,eAAA;EACA,WAAA;EACA,mBAAA;EACA,mBAAA;AAEF;;AACA;EACE,cDvDW;ECwDX,eAAA;EACA,WAAA;EACA,mBAAA;AAEF;;AACA;EACE,kBAAA;EACA,qBAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA,gBAAA;AAEA;EACE;IACE,sBAAA;IACA,oBAAA;EACF;EACA;IACE,cAAA;EACF;EACA;IACE,UAAA;EACF;EACA;IACE,mBAAA;IACA,eAAA;EACF;EACA;IACE,eAAA;IACA,YAAA;EACF;EACA;IACE,eAAA;EACF;EACA;IACE,WAAA;IACA,YAAA;IACA,qBAAA;IACA,iBAAA;EACF;AACF;AAEA;EACE;IACE,kBAAA;EAAF;EAEA;IACE,eAAA;EAAF;EAEA;IACE,WAAA;EAAF;EAEA;IACE,gBAAA;IACA,WAAA;IACA,YAAA;IACA,mBAAA;IACA,eAAA;EAAF;EAEA;IACE,cAAA;IACA,YAAA;EAAF;AACF","sourcesContent":["/* Change colors in this file to style to your needs on a global level. \nCertain colors are used for different and multiply types of elements. \nFor greater control over colors visit each components .scss file. */\n\n// button colors\n$buttonColor: #55198b;\n$buttonHover: #8c43ce;\n$topButtonHover: #000;\n\n// text colors light theme\n$titleColor: #000000;\n$textColor: #000000;\n$subTitle: #868e96;\n$cardSubtitle: #666666;\n$talkCardSubTitle: #7f8287;\n$blogCardTitleColor: #262626;\n\n// text color dark theme\n$textColorDark: #ffffff;\n\n// toggle switch colors\n$toggleCheck: #2196f3;\n$toggleSwitchSliderBG: #ccc;\n\n// githubRepo specific colors\n$githubRepoCardLanguageColorBG: #0000ff;\n$githubRepoCardColor: rgb(88, 96, 105);\n$githubRepoCardRepoCardStatsColor: rgb(106, 115, 125);\n$githubRepoCardRepoNameColor: rgb(36, 41, 46);\n$githubProfileCardLocationTS: #ffebcd;\n$githubProfileCardBorder: #6c63ff;\n\n// light background colors\n$lightBackground1: #fff;\n$lightBackground2: rgb(255, 255, 255);\n$lightBackground3: #f5f2f4;\n$blogCardContainerColor: #586069;\n// dark background colors\n$darkBackground: #171c28;\n\n// light theme box shadows\n$lightBoxShadowDark: rgba(0, 0, 0, 0.2);\n$lightBoxShadow: rgba(0, 0, 0, 0.1);\n$lightBoxShadowDarker: rgba(0, 0, 0, 0.3);\n\n// dark theme box shadows\n$darkBoxShadow: #d9dbdf;\n$darkBoxShadow2: #ffffff;\n\n// linear gradients\n$experienceCardBlurredDivLG: linear-gradient(\n  rgba(0, 0, 0, 0.4),\n  rgba(0, 0, 0, 0.2)\n);\n$experienceCardBannerLG: linear-gradient(\n  rgba(0, 0, 0, 0.7),\n  rgba(0, 0, 0, 0.5)\n);\n\n// borders\n$progressBarBackground: rgb(243, 239, 239);\n$lightBorder1: rgba(211, 211, 211, 0.397);\n$educationCardBorder: #a9a7f9;\n\n// hovers\n$achievementCertificateCardHoverDark: rgba(255, 255, 255, 0.2);\n$blogCardHoverSmallColor: rgba(255, 255, 255, 0.8);\n$headerHoverBG: #f4f4f4;\n$contactDetailHoverTS: #b5b5b5;\n\n// misc backgrounds\n$progressBarSpanBG: #aaa5ff;\n$iconBackground: #333;\n$appHeaderBG: #282c34;\n\n// misc colors\n$skillsColor: #645beb;\n$appLink: #09d3ac;\n\n// social media icons\n$faceBook: #3b5998;\n$linkedin: #0e76a8;\n$github: #333;\n$gitlab: #fca326;\n$google: #ea4335;\n$twitter: #1da1f2;\n$medium: #000;\n$stackoverflow: #f48024;\n$instagram: #c13584;\n$kaggle: #20beff;\n","@import \"../../_globalColor\";\n\n.education-card {\n  display: flex;\n  flex-direction: row;\n}\n\n.education-card:hover + .education-card-border {\n  border-color: $educationCardBorder;\n  width: 100%;\n  -webkit-transition: width 0.6s ease-in-out;\n  -moz-transition: width 0.6s ease-in-out;\n  -o-transition: width 0.6s ease-in-out;\n  transition: width 0.6s ease-in-out;\n}\n\n.education-card-border {\n  height: 30px;\n  width: 80%;\n  border-top: 2px solid $lightBorder1;\n  margin-bottom: 20px;\n  -webkit-transition: width 0.6s ease-in-out;\n  -moz-transition: width 0.6s ease-in-out;\n  -o-transition: width 0.6s ease-in-out;\n  transition: width 0.6s ease-in-out;\n}\n\n.education-head {\n  display: flex;\n  flex-direction: row;\n}\n\n.education-text-school {\n  margin: 0;\n  font-size: 28px;\n  font-weight: 700;\n  text-overflow: ellipsis;\n  overflow: hidden;\n  white-space: nowrap;\n  height: 27px;\n}\n\n.education-roundedimg {\n  object-fit: cover;\n  margin-right: 2rem;\n  width: 6rem;\n  height: 6rem;\n  box-shadow: 0 0.5rem 1rem $lightBoxShadowDarker;\n  border-radius: 50%;\n}\n\n.education-card-right {\n  max-width: 70%;\n}\n\n.education-text-subHeader {\n  color: $textColor;\n  font-weight: 700;\n  font-size: 19px;\n  margin: 0px;\n  padding-top: 0.8rem;\n  line-height: normal;\n}\n\n.education-text-duration {\n  color: $titleColor;\n  font-size: 19px;\n  margin: 0px;\n  padding-top: 0.5rem;\n}\n\n.education-text-desc {\n  margin-top: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.education-text-bullets > ul {\n  margin-top: 0.5rem;\n}\n\n/* Media Query */\n\n@media (max-width: 1380px) {\n  .education-card {\n    flex-direction: column;\n    padding-bottom: 10px;\n  }\n  .education-card-right {\n    max-width: 90%;\n  }\n  .education-card-border {\n    width: 90%;\n  }\n  .education-text-subHeader {\n    padding-top: 0.5rem;\n    font-size: 16px;\n  }\n  .education-text-school {\n    font-size: 20px;\n    height: 23px;\n  }\n  .education-text-duration {\n    font-size: 16px;\n  }\n  .education-roundedimg {\n    width: 4rem;\n    height: 4rem;\n    margin-bottom: 0.5rem;\n    margin-right: 0px;\n  }\n}\n\n@media (max-width: 768px) {\n  .education-card {\n    text-align: center;\n  }\n  .education-card-right {\n    max-width: 100%;\n  }\n  .education-card-border {\n    width: 100%;\n  }\n  .education-roundedimg {\n    margin-top: 10px;\n    width: 4rem;\n    height: 4rem;\n    margin-bottom: 1rem;\n    margin-right: 0;\n  }\n  .education-text-bullets > ul {\n    max-width: 80%;\n    margin: auto;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
